/**
 * A position.
 *
 * @property {number} latitude  - In decimal degree.
 * @property {number} longitude - In decimal degree.
 */
export class Position {
    /**
     * Creates a new position.
     *
     * @param {number} latitude     - In decimal degree.
     * @param {number} longitude    - In decimal degree.
     */
    constructor(latitude, longitude) {
        this.latitude = latitude
        this.longitude = longitude
    }
}
